import React from 'react';
import { Provider } from 'react-redux';
import UserflowTheme from '@lt/components/themes/userflow';

import ErrorBoundary from 'src/error/components/ErrorBoundary';
import { setPageColors } from 'src/hooks/setPageColors';
import { getStore } from './store';

import Header from '../../components/Header';
import '../../global.css';

type Props = {
  store?: any;
  [k: string]: any;
};

const HeaderApp = ({ store, ...rest }: Props) => {
  const newStore = store || getStore(rest);

  const isWhitelabel = newStore?.getState().get('view').get('isWhitelabel');

  const { wlPartnerSettings } = window;

  try {
    if (isWhitelabel && wlPartnerSettings)
      setPageColors({
        primary: wlPartnerSettings.primary,
        primaryColor: wlPartnerSettings.primaryColor,
        primaryHeader: wlPartnerSettings.primaryHeader,
        primaryHeaderColor: wlPartnerSettings.primaryHeaderColor,
        secondary: wlPartnerSettings.secondary,
        secondaryColor: wlPartnerSettings.secondaryColor,
        secondaryHeader: wlPartnerSettings.secondaryHeader,
        secondaryHeaderColor: wlPartnerSettings.secondaryHeaderColor,
        background: wlPartnerSettings.background,
      });
  } catch (e) {
    console.log(e);
  }

  return (
    <ErrorBoundary>
      <Provider store={newStore}>
        <UserflowTheme>
          <Header shouldFetchClientInfo />
        </UserflowTheme>
      </Provider>
    </ErrorBoundary>
  );
};

export default HeaderApp;
